<template>
  <div>
    <label v-if="textFloat" class="main-label"> {{ textFloat }}</label>

    <v-select
      v-model="selected"
      :options="paginated"
      :label="textField"
      :filterable="false"
      @open="onOpen"
      @close="onClose"
      @input="push"
      :multiple="multiple"
      :placeholder="placeholder"
      :closeOnSelect="multiple ? false : true"
      :clearSearchOnSelect="false"
      :clearSearchOnBlur="clearSearchOnBlur"
      @search="(query) => (search = query)"
      :taggable="multiple"
      :clearable="clearable"
      :class="multiple ? 'multiple-select' : 'single-select'"
    >
      <template #search="{ attributes, events }">
        <input
          v-if="searchPlaceHolder"
          class="vs__search w-100"
          :placeholder="placeholder"
          v-bind="attributes"
          v-on="events"
        />
      </template>
      <template #list-footer>
        <li v-show="hasNextPage" ref="load" class="loader">
          Loading more options...
        </li>
      </template>
    </v-select>
    <!-- <multiselect
      v-model="valueCountries"
      id="ajax"
      label="name"
      track-by="code"
      placeholder="Type to search"
      open-direction="bottom"
      :options="countries"
      :multiple="true"
      :searchable="true"
      :loading="isLoading"
      :internal-search="false"
      :clear-on-select="false"
      :close-on-select="false"
      :options-limit="300"
      :limit="3"
      :limit-text="limitText"
      :max-height="600"
      :show-no-results="false"
      :hide-value="true"
      @search-change="asyncFind"
    >
      <template slot="tag" slot-scope="{ option, remove }"
        ><span class="custom__tag"
          ><span>{{ option.name }}</span
          ><span class="custom__remove" @click="remove(option)">❌</span></span
        ></template
      >
      <template slot="clear" slot-scope="props">
        <div
          class="multiselect__clear"
          v-if="valueCountries.length"
          @mousedown.prevent.stop="clearAll(props.search)"
        ></div> </template
      ><span slot="noResult"
        >Oops! No elements found. Consider changing the search query.</span
      >
    </multiselect> -->
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";
export default {
  name: "SelectWithInfinite",

  props: {
    options: {
      required: true,
      default: [],
    },
    value: {
      required: false,
      default: [],
    },
    textField: {
      required: false,
      default: "name",
    },
    valueField: {
      required: false,
      default: "id",
    },
    limit: {
      required: false,
      default: 100,
    },
    textFloat: {
      required: false,
    },
    placeholder: {
      required: false,
    },
    multiple: {
      required: false,
      default: true,
    },
    rawValue: {
      required: false,
      type: Boolean,
      default: false,
    },
    clearable: {
      required: false,
      default: true,
    },
  },
  data() {
    return {
      observer: null,
      search: "",
      selected: [],
      limitValue: this.limit,
      searchPlaceHolder: false,
    };
  },

  computed: {
    filtered() {
      if (this.options.length > 0)
        return this.options.filter((options) =>
          options[this.textField]
            .toLowerCase()
            .includes(this.search.toLowerCase())
        );
      else return [];
    },
    paginated() {
      return this.filtered.slice(0, this.limitValue);
    },
    hasNextPage() {
      return this.paginated.length < this.filtered.length;
    },
  },
  watch: {
    options(val) {
      if (val)
        if (this.multiple) {
          this.selected = this.options.filter(
            (el) => this.value == el[this.valueField]
          );
        } else {
          this.selected = this.options.filter(
            (el) => this.value == el[this.valueField]
          );
        }
    },
  },
  mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll);

    if (this.options.length > 0)
      if (this.multiple) {
        this.selected = this.options.filter(
          (el) => this.value == el[this.valueField]
        );
      } else {
        this.selected = this.options.filter(
          (el) => this.value == el[this.valueField]
        );
      }
  },
  methods: {
    async onOpen() {
      this.searchPlaceHolder = true;
      this.search = "";
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },
    onClose() {
      this.observer.disconnect();
      this.search = "";

      this.searchPlaceHolder = false;
    },

    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;
        this.limitValue += 10;
        // this.getProductList();
        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
    push(e) {
      let value = null;
      if (this.multiple) {
        value = e.map((el) => el[this.valueField]);
      } else if (this.rawValue) value = e[this.valueField];
      else {
        value = [e[this.valueField]];
      }
      // this.selected = ;
      this.$emit("input", value);
    },
    clearSearchOnBlur(a, b) {
      return true;
    },
  },
};
</script>

<style>
.vs__search {
  color: #3c4b64 !important;
}
.vs__search:focus {
  border-color: transparent !important;
}
.vs__dropdown-option--selected {
  background-color: var(--primary-color) !important;
  color: var(--font-primary-color) !important;
}

.multiple-select > .vs__selected {
  background-color: var(--primary-color) !important;
  color: var(--font-primary-color) !important;
}
.vs--single.vs--open .vs__selected {
  opacity: 1 !important;
  position: relative !important;
}
.vs--searchable .vs__dropdown-toggle {
  cursor: pointer !important;
}
ul li {
  color: black !important;
}
</style>
